<h4 translate>In your team</h4>

<app-access
    [usersWithAccess]="ticket.teammatesWithAccess"
    [isLoaded]="ticket.id"
    [nonUsersText]="'There are no assigned users yet on this ticket' | translate"
    [userType]="userSearchTypeEnum.team"
    [ticketId]="ticket.id"></app-access>

<hr />

<h4 translate>External users</h4>

<app-access
    [usersWithAccess]="ticket.vendorsWithAccess"
    [isLoaded]="ticket.id"
    [nonUsersText]="
        'No external users have been given access to this ticket yet. Give access by clicking on the button below.'
            | translate
    "
    [userType]="userSearchTypeEnum.vendors"
    [ticketId]="ticket.id"></app-access>
